import * as React from "react";
import ImageView from "../../../../components/SmartImage";
import { DiscountInfoCard, TagWidthSoldOut } from "./DiscountInfoCard";
import { PriceViews } from "../../NormalProducts/PriceViews";
import { NameViews } from "../../NormalProducts/NameViews";
import { ActTagViewForPc } from "../../NormalProducts/ActTagViews";
import { ProductCardWrap, DescriptionWrap, ProductCardPoster, DescriptSuffix } from "./styles";
import { ModuleLayoutStyle } from "../../../../services/playground";
import { TActState } from "../../../../services/product";
export class ProductCard extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onClick = () => {
            var _a;
            if (this.props.onClick) {
                this.props.onClick((_a = this.props.product) === null || _a === void 0 ? void 0 : _a.gpid);
            }
        };
        this.state = {};
    }
    render() {
        const { product, placeholderBg = "", actState, isActive, } = this.props;
        const { flash, titleIcon, actTags } = product.extra || {};
        return (React.createElement(ProductCardWrap, { target: "_blank", width: this.props.width, href: product.url, onClick: this.onClick },
            React.createElement(ProductCardPoster, { style: {
                    background: `url(${placeholderBg}) center`,
                    backgroundSize: "contain",
                } },
                React.createElement(DiscountInfoCard, { discount: flash === null || flash === void 0 ? void 0 : flash.discount }),
                product.isSoldout && React.createElement(TagWidthSoldOut, null),
                React.createElement(ImageView, { src: product === null || product === void 0 ? void 0 : product.img, online: true, placeholder: placeholderBg, fallbackSrc: placeholderBg, imgClass: "productImage", style: {
                        width: "100%",
                    } })),
            React.createElement(DescriptionWrap, null,
                !isActive && (React.createElement(React.Fragment, null,
                    React.createElement(NameViews, { name: product.name, columnNum: actTags ? 1 : 2, titleTag: (titleIcon === null || titleIcon === void 0 ? void 0 : titleIcon.img) || "" }),
                    actTags && React.createElement(ActTagViewForPc, { actTags: actTags }),
                    React.createElement(PriceViews, { className: `priceView${ModuleLayoutStyle.Orange}`, price: product.price, originPrice: product.originPrice, isFlash: true }))),
                React.createElement(DescriptSuffix, null,
                    React.createElement("span", null,
                        React.createElement("b", null, product.stock),
                        " pcs ",
                        actState === TActState.OnGoing && "left"),
                    actState === TActState.OnGoing && (React.createElement("a", { className: "buyNow", href: product.url, target: "_blank" }, "Buy Now")),
                    actState === TActState.ComingSoon && (React.createElement("a", { className: "comingSoon", href: product.url, target: "_blank" }, "Coming Soon"))))));
    }
}
